module.exports = __webpack_public_path__ + "static/img/IMG_20241205_185416.5585f6e7.jpg";